import { render } from "./EditSurveyQuestionsView.vue?vue&type=template&id=116b1bee&lang=pug"
import script from "./EditSurveyQuestionsView.vue?vue&type=script&lang=js"
export * from "./EditSurveyQuestionsView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__